'use strict';

//angular.module('Authentication');
//angular.module('Processing');

/*
import KatalyoCtrls from '../../0001_index/angularJS/katalyoCtrls.js';
var moduleName='settingsCtrls';
export default moduleName;

var module = angular.module('KatalyoCtrls',KatalyoCtrls);
*/
export default function codesDataCtrl ($scope, $rootScope,uiGridConstants,$http,ProcessingService,MessagingService,CodesService) {
    
    $scope.CTRLNAME='codesDataCtrl';
    $scope.isCollapsed  = false;
  // $scope.isCollapsed2  = true;
    //$scope.$scope = $scope;
    //Get data from server
    var colDefs1 = [
         { name: 'id', displayName: 'ID', type: 'number', width:'7%',enableHiding: false, visible: true },
         { name: 'CodesHeadLang[0].CodeName', displayName: 'Code name',enableCellEdit: true},
         { name: 'CodeHeadName', displayName: 'Code unique identifier'},
         { name: 'CodesHeadLang[0].Description', displayName: 'Code description' },
         { name: 'Status.name', displayName: 'Status'},
         { name: 'CodeType.name', displayName: 'Code Type'},
         { name: 'Version', displayName: 'Version'},
         { name: 'CodesHeadLang[0].Lang.name', displayName: 'Language'},
         ];
    $scope.gridOptions1 = {
        columnDefs: colDefs1,
      enableGridMenu: true,
        showGridFooter: true,
    showColumnFooter: true,
        enableRowSelection: true,
       multiSelect: false,
       enableHorizontalScrollbar : 0, 
      enableVerticalScrollbar : 2,
       enableFiltering: true,
       enableRowHeaderSelection: true,
       enableColumnResizing: true,
     /* 
        paginationPageSizes: [5, 10, 20, 50, 100],
         paginationPageSize: 5,
       enableSelectAll: false,
       
      
       
       enableCellEdit: false*/
      
   }
   
    $scope.setDirectiveFn = function(directiveFn) {
        $scope.directiveFn = directiveFn;
    };

    $scope.gridOptions1.onRegisterApi = function (gridApi1) {
        //set gridApi on scope
        $scope.gridApi1 = gridApi1;
        gridApi1.selection.on.rowSelectionChanged($scope,function(row){
          $scope.codeSelected=row.isSelected
          
          
          $scope.selectedCode = row.entity.id;
          if (!$scope.codeSelected)
          {
            $scope.selectedCode = 0;
            
          }
          $scope.selectedCodeLang=row.entity.CodesHeadLang[0].Lang;
          $scope.CodeHeadLang={CodeName: row.entity.CodesHeadLang[0].CodeName,CodesHeadId: row.entity.id,Description:row.entity.CodesHeadLang[0].Description,Lang:row.entity.CodesHeadLang[0].Lang};
          $scope.directiveFn($scope.selectedCode,$scope.CodeHeadLang.CodeName);
          
          //populate other languages
       /*   if(row.isSelected){
            $scope.getOtherLanguages($scope.selectedCode);
            $scope.isCollapsed = !$scope.isCollapsed
          }
         */ 
          });
          
     }

    var colDefs2 = [
         { name: 'id', displayName: 'ID', type: 'number', width:'7%',enableHiding: false, visible: true },
         { name: 'CodeName', displayName: 'Code name',enableCellEdit: true},
         { name: 'Description', displayName: 'Code description',enableCellEdit: true},
         { name: 'Lang', displayName: 'Language'},
         { name: 'CodesHeadId', displayName: 'Code name',visible:false},
         ];
    $scope.gridOptions2 = {
        columnDefs: colDefs2,
      enableGridMenu: true,
        showGridFooter: true,
    showColumnFooter: true,
        enableRowSelection: true,
       multiSelect: false,
       enableHorizontalScrollbar : 0,
       enableVerticalScrollbar : 2,
       enableFiltering: true,
       enableRowHeaderSelection: true,
       enableColumnResizing: true,
          
   }
   
    $scope.gridOptions2.onRegisterApi = function (gridApi2) {
        //set gridApi on scope
        $scope.gridApi2 = gridApi2;
        gridApi2.selection.on.rowSelectionChanged($scope,function(row){
       
        $scope.codeLangSelected=row.isSelected
         //populate details
           if(row.isSelected){
              
              $scope.getCodesDetails($scope.selectedCode,row.entity.Lang.id);
               $scope.CodeHeadLang={id:row.entity.id,CodeName: row.entity.CodeName,CodesHeadId: row.entity.CodesHeadId,Description:row.entity.Description,Lang:row.entity.Lang};
           }
        });
    }
    
          $scope.getOtherLanguages = function(id){
        
         $scope.isCollapsed = !$scope.isCollapsed;
         $scope.gridOptions3.data =[];
        
         
                    
                    CodesService.getCodesHeadLang(id).then(function(data) {
                                
                                  $scope.data2 = data.data;
                                  $scope.gridOptions2.data = $scope.data2;
                                  $scope.getCodesDetails($scope.selectedCode,$scope.data2[0].Lang);
                                 
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
                      
        
        
        
       }
     
      var colDefs3 = [
         { name: 'id', displayName: 'ID', type: 'number', width:'10%',enableHiding: false, visible: true },
         { name: 'CodesHeadId', displayName: 'Codes head ID',visible:false},
         { name: 'CodesDetailLang[0].Lang.name', displayName: 'Language'},
         { name: 'CodesDetailLang[0].CodesDetailId', displayName: 'Codes Detail Id',visible:false}, 
         { name: 'Name', displayName: 'Name'},
         { name: 'Status.name', displayName: 'Status'},
         { name: 'CodesDetailLang[0].Value', displayName: 'Value'},
         { name: 'CodesDetailLang[0].id', displayName: 'codesdetaillang_id',visible:false},
         { name: 'CodesDetailLang[0].CreatedBy.username', displayName: 'Created By'},
         { name: 'CodesDetailLang[0].CreatedDateTime', displayName: 'Date Created', type:'date',cellFilter:'date:\'dd.MM.yyyy HH:MM:ss:ms\''},
         { name: 'CodesDetailLang[0].ChangedBy.username', displayName: 'Changed By'},
         { name: 'CodesDetailLang[0].ChangedDateTime', displayName: 'Date Changed', type:'date',cellFilter:'date:\'dd.MM.yyyy HH:MM:ss:ms\''},
         ];
    $scope.gridOptions3 = {
        columnDefs: colDefs3,
      enableGridMenu: true,
        showGridFooter: true,
    showColumnFooter: true,
        enableRowSelection: true,
       multiSelect: false,
       enableHorizontalScrollbar : 2, 
      enableVerticalScrollbar : 2,
       enableFiltering: true,
       enableRowHeaderSelection: true,
       enableColumnResizing: true,
          
   }
   
    $scope.gridOptions3.onRegisterApi = function (gridApi) {
        //set gridApi on scope
        $scope.gridApi3 = gridApi;
        gridApi.selection.on.rowSelectionChanged($scope,function(row){
          
            $scope.codeItemSelected=row.isSelected
           //change code details
          if(row.isSelected){      
           //$scope.getCodesDetails(row.entity.CodesHeadId.id,row.entity.Lang);
           if (row.entity.CodesDetailLang.length>0) {
              $scope.CodesDetailLang={CodesDetailId:{CodesDetailId_id:row.entity.id, CodesHeadId:row.entity.CodesHeadId, Name:row.entity.Name,Status:row.entity.Status}
              ,id:row.entity.CodesDetailLang[0].id, Lang:row.entity.CodesDetailLang[0].Lang, Value:row.entity.CodesDetailLang[0].Value,
              CreatedBy:row.entity.CodesDetailLang[0].CreatedBy,CreatedDateTime:row.entity.CodesDetailLang[0].CreatedDateTime,
              ChangedBy:row.entity.CodesDetailLang[0].ChangedBy,ChangedDateTime:row.entity.CodesDetailLang[0].ChangedDateTime };
              
              }else{
               $scope.CodesDetailLang={CodesDetailId:{id:row.entity.id, CodesHeadId:row.entity.CodesHeadId, Name:row.entity.Name,Status:row.entity.Status}};
   
                      }
           
          } 
          });
       
 
        
     }

     $scope.isCollapsedEditItem = false;
     
    $scope.editCodeItem = function(){
        
        
        //populate from grid
        $scope.codeItemHeader={Text: 'Edit code item',Type:'Edit'};
         if ($scope.CodesDetailLang.Lang==undefined) {
          //code
           $scope.CodesDetailLang.Lang=$scope.CodeHeadLang.Lang;
        }
         $scope.CodesDetailLang.CreatedBy=null;
         $scope.CodesDetailLang.ChangedBy=null;
        
        $scope.isCollapsedEditItem = !$scope.isCollapsedEditItem;
        
        
    }
    
  $scope.CodesDetail = {codesdetaillang_set: []};
  $scope.CodesDetailLang ={CodesDetailId:{}}; 
      $scope.newCodeItem = function(){
        
        $scope.codeItemHeader={Text: 'New code item',Type:'New'};
        //populate from grid
        $scope.isCollapsedEditItem = !$scope.isCollapsedEditItem;
        $scope.CodesDetailLang.id=undefined;
        $scope.CodesDetailLang.Lang=$scope.CodeHeadLang.Lang;
        $scope.CodesDetailLang.CodesDetailId.CodesHeadId=$scope.CodeHeadLang.CodesHeadId;
        }
     
    $scope.editCodeLang = function(){
        
        
        //populate from grid
        $scope.isCollapsedEditLang = !$scope.isCollapsedEditLang
       
    }
     
      $scope.saveCodeLang = function(id){
        
        
        $scope.isCollapsedEditLang = !$scope.isCollapsedEditLang
   
   
        CodesService.CodesPost($scope.CodeHead).then(function(data) {
                                
                                   $scope.data1 = data.data;
                                    $scope.gridOptions1.data = $scope.data1;
                                 
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
   
   
      
    }
     
    $scope.getListOfCodes = function(){
      
        var lang=$rootScope.globals.currentUser.lang;
       CodesService.CodesGet(lang).then(function(data) {
                                
                                   $scope.data1 = data.data;
                                    $scope.gridOptions1.data = $scope.data1;
                                 
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
       
      
    }
    
        
    
    $scope.getListOfCodes();
    
    
     
      $scope.saveCodeItem = function (isValid) {

           if (isValid) {
              //var codesStatus = CODES_LIST._CODE_STATUS_LIST_;
            $scope.CodesDetailLang.CodesDetailId.Status = 'Active';
        
                CodesService.addUpdateCodesDetails($scope.codeItemHeader.Type,$scope.CodesDetailLang).then(function(data) {
                                
                                  MessagingService.addMessage(data.msg,'success');
                                 
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
          }
        };
      
    }
export function codesDetailsCtrl ($scope, $rootScope,uiGridConstants,CodesService) {
    
       $scope.CTRLNAME='codesDetailsCtrl';
        //Get data from server
        var colDefs = [
         { name: 'id', displayName: 'ID', aggregationType: uiGridConstants.aggregationTypes.max,type: 'number', width:'5%',enableHiding: false, visible: true },
         { name: 'CodeName', displayName: 'Code name'},
         { name: 'Description', displayName: 'Code description' },
         { name: 'Status', displayName: 'Status'},
         { name: 'Lang', displayName: 'Language',cellFilter:"getCodeByName: 'languages'"},
         ];
    $scope.gridOptions = {
        columnDefs: colDefs,
      enableGridMenu: true,
        showGridFooter: true,
    showColumnFooter: true,
        enableRowSelection: true,
       multiSelect: false,
       enableHorizontalScrollbar : 0, 
      enableVerticalScrollbar : 2,
       enableFiltering: true,
       enableRowHeaderSelection: true,
       enableColumnResizing: true,
     /* 
        paginationPageSizes: [5, 10, 20, 50, 100],
         paginationPageSize: 5,
       enableSelectAll: false,
       
      
       
       enableCellEdit: false*/
      
   }
   

    $scope.gridOptions.onRegisterApi = function (gridApi) {
        //set gridApi on scope
        $scope.gridApi = gridApi;
        gridApi.selection.on.rowSelectionChanged($scope,function(row){ $scope.codeSelected=row.isSelected});
    
     }
    
    $scope.getListOfCodes = function(){
      
      var lang=$rootScope.globals.currentUser.lang;
      CodesService.CodesGet(lang).then(function(data) {
                                
                                   $scope.data = data.data;
                                    $scope.gridOptions.data = $scope.data;
                                 
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
       
    }
    
    getListOfCodes();
  
    
     
    }
export function codesNewCtrl ($scope, $rootScope,$http,uiGridConstants,ProcessingService,MessagingService,CodesService) {
    
    $scope.CodeHead = {CodesHeadLang:[]};
    $scope.CTRLNAME='codesNewCtrl';
    $scope.activity.activityMessage = ProcessingService.setActivityMsg('Processing request');
    
    $scope.setDirectiveFn = function(directiveFn) {
        $scope.directiveFn = directiveFn;
    };
    
    var lang=$rootScope.globals.currentUser.lang;
     
     CodesService.getCodesByName('languages',lang).then(function (data) {
                                $scope.codeLanguageList = data.data;
                             });
     CodesService.getCodesByName('_CODE_TYPE_LIST_',lang).then(function (data) {
                                $scope.codeTypeList = data.data;
                             });
     
      CodesService.getCodesByName('codestatus',lang).then(function (data) {
                                $scope.codeStatusList = data.data;
                             });
      
    $scope.saveNewCode = function (isValid) {

          //  $scope.auction.currentUser = $rootScope.globals.currentUser;

          if (isValid) {
    
            $scope.activity.activityMessage = ProcessingService.setActivityMsg('Saving code '+$scope.CodeHead.CodesHeadLang[0].CodeName);
            $scope.CodeHead.Version=1;
              
               CodesService.CodesPost($scope.CodeHead).then(function(data) {
                                
                                   MessagingService.addMessage(data.data.msg,'success');
                                   $scope.CodeHead.id=data.data.data;
                                   
                                   $scope.directiveFn($scope.CodeHead.id,$scope.CodeHead.CodesHeadLang[0].CodeName);
                                 
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg.data,'error');
                            });                             
           
            
          }
        };
        
       
    }
export function codesEditCtrl ($scope, $rootScope,$http,uiGridConstants,ProcessingService,MessagingService,CodesService,$stateParams) {
    
     $scope.CTRLNAME='codesEditCtrl';
    
    var lang=$rootScope.globals.currentUser.lang;

    $scope.activity.activityMessage = ProcessingService.setActivityMsg('Processing request');
     
    CodesService.getCodesByName('languages',lang).then(function (data) {
                                $scope.codeLanguageList = data.data;
                             });
     CodesService.getCodesByName('_CODE_TYPE_LIST_',lang).then(function (data) {
                                $scope.codeTypeList = data.data;
                             });
     
      CodesService.getCodesByName('codestatus',lang).then(function (data) {
                                $scope.codeStatusList = data.data;
                             });
    $scope.codeId = $stateParams.id;
    
     $scope.getCode = function (codeid) {
      
       
       CodesService.CodesGetById($scope.codeId,lang).then(function(data) {
                                
                    $scope.CodeHead = data.data[0];
         },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });                             
           
     }
     
     $scope.getCode($scope.codeId);
     
      $scope.clear = function(event, select)
      
      {
        select.selected = null;
        
      }
    $scope.saveCode = function (isValid) {

          //  $scope.auction.currentUser = $rootScope.globals.currentUser;

          if (isValid) {
    
            $scope.activity.activityMessage = ProcessingService.setActivityMsg('Saving code '+$scope.CodeHead.CodesHeadLang[0].CodeName);
            //$scope.CodeHead.Version=1;
              
               CodesService.CodesPost($scope.CodeHead).then(function(data) {
                                
                                   MessagingService.addMessage(data.data,'success');
                                 
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });                             
           
            
          }
        };
        
       
    }
export function userDetailsCtrl ($scope, $rootScope, $location, $timeout,AuthenticationService,ProcessingService,MessagingService,CodesService) {
    
     $scope.CTRLNAME='userDetailsCtrl';
    var lang=$rootScope.globals.currentUser.lang;    
    //$scope.strongPassRegex = "^(?=.*[A-Z].*[A-Z])(?=.*[!@#$&()=\|+/-?:.;,_//*])(?=.*[0-9].*[0-9])(?=.*[a-z].*[a-z]).{8,}$";
    
    $scope.strongPassRegex ="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#%&<>;:,_/'\"\$\\s\*\(\)\=\?\+\^\.\-]).{8,}$";
    // var special =\\\\ \| \(\)\=\?\+\^\-\.
    
    CodesService.getCodesByName('languages',lang).then(function (data) {
                                $scope.codeLanguageList = data.data;
                                $scope.user = $rootScope.globals.currentUser;
    });
         
       $scope.getUser = function () {
 
      };
      
      $scope.validate_pass2 = function (form) {
        
        if (form.pass1.$valid && $scope.pass1!=$scope.pass2) form.pass2.$setValidity('pass2',false);
        else if (form.pass1.$valid && $scope.pass1==$scope.pass2) form.pass2.$setValidity('pass2',true);
        else form.pass2.$setValidity('pass2',false);
      };
      
      $scope.getUser();
      $scope.saveUser = function (isValid) {
              
      };
    $scope.change_password = function() {
        
        AuthenticationService.ChangePassword($scope.currentPass,$scope.pass1).then(function (data) {
            MessagingService.addMessage(data.data.msg,'success');
            AuthenticationService.UpdateAuthToken(data.data.token);
        }
        ,function(error){
            MessagingService.addMessage(error.data.msg,'error');
        });
    };
       
      
    }
export function usersDefinitionCtrl ($scope, $rootScope, $timeout,UserService,MessagingService,CodesService) {
    
     $scope.CTRLNAME='usersDefinitionCtrl';
    var lang=$rootScope.globals.currentUser.lang;    
    $scope.newUser=true;            
    CodesService.getCodesByName('languages',lang).then(function (data) {
                                $scope.codeLanguageList = data.data;
                                
    });
        
        $scope.getGroups = function () {
          UserService.getUsersGroups('groups').then(function(data){
          $scope.groupList = data.data;
				});

        };
        $scope.getGroups();
        $scope.editUser = function (user,index) {  
            $scope.selectedUser = angular.copy(user); //MIGOR - dodao CLONE za test
            $scope.newUser=false;
            $scope.selectedIndex=index;
        };

        
       $scope.getUsersExtended = function () {
          UserService.getUsersExtended().then(function(data){
          $scope.users = data.data;
				});

        };
				//$scope.getUsers();
        $scope.getUsersExtended();
      
       $scope.newUserFunc = function (form) {
          $scope.newUser=true;
          $scope.selectedUser = {'UserId':null,'Lang':null};
          if (form!=undefined)
          {
            form.$setPristine();
            if (form.username!=undefined) form.username.$setUntouched();
            //form.password.$setUntouched();
            if (form.first_name!=undefined) form.first_name.$setUntouched();
            if (form.last_name!=undefined) form.last_name.$setUntouched();
            if (form.email!=undefined) form.email.$setUntouched();
            if (form.lang!=undefined) form.lang.$setUntouched();
          }
       };
      $scope.saveUser = function (isValid) {
          
           if (isValid) {
            
             UserService.SaveUser($scope.selectedUser).then(function(data) {
                                
                                   
                                   MessagingService.addMessage(data.data.msg,'success');
                                   $scope.selectedUser=data.data.user;
                                   if ($scope.newUser)
                                   {
                                    
                                    $scope.users.push($scope.selectedUser);
                                    $scope.newUser=false;
                                   }else{
                                    $scope.users[$scope.selectedIndex] = $scope.selectedUser;
                                    
                                   }
                                  
                                   //find and update user
                                   
                                 
                              },function(error){
                                
                                  MessagingService.addMessage(error.data.msg,'error');
                            });                
             
            } 
        
        
      };
       
      
    }
export function groupsCtrl ($scope, $rootScope, $timeout,UserService,MessagingService,CodesService) {
    
     var lang=$rootScope.globals.currentUser.lang; 
     $scope.CTRLNAME='groupsCtrl';
   	   
        
    CodesService.getCodesByName('languages',lang).then(function (data) {
                                $scope.codeLanguageList = data.data;
                                
    });
        
        $scope.editGroup = function (group,index) {  
          $scope.selectedGroup = angular.copy(group);
          $scope.isShowNewGroup=false;
		$scope.selectedIndex=index;
        		};

         $scope.deselectGroup = function () {  
            $scope.newGroup = null;
            $scope.selectedGroup = null;
            $scope.isShowNewGroup=false;

		};
        
        $scope.showNewGroup = function (form) {
            
            if (form!=undefined)
            {
                form.$setPristine();
                if (form.groupName!=undefined) form.groupName.$setUntouched();
            }
           $scope.isShowNewGroup=true;
           $scope.selectedGroup=$scope.newGroup;
       }
        
       $scope.getUsers = function () {
          UserService.getUsersGroups('users').then(function(data){
          $scope.userList = data.data;
				});
        };
        
       $scope.getGroupsExtended = function () {
          UserService.getGroupsExtended().then(function(data){
          $scope.groups = data.data;
				});

        };
        

       
       
        //Execute this
        $scope.getUsers();
        $scope.getGroupsExtended(); 

    
    
      $scope.saveGroup = function (selectedGroup,isValid) {
          
           if (isValid) {
            
             UserService.SaveGroup(selectedGroup).then(function(data) {
                                
                                   
                                   MessagingService.addMessage(data.data.msg,'success');
                                   $scope.selectedGroup=data.data.group;
                                   if (selectedGroup.id == null)
                                   {
                                    
                                    $scope.groups.push($scope.selectedGroup);
                                   }
                                   else
                                   {
                                     $scope.groups[$scope.selectedIndex] = $scope.selectedGroup;
                                   }
                                   $scope.deselectGroup();
                                 
                              },function(error){
                                
                                  MessagingService.addMessage(error.data.msg,'error');
                            });                
             
            } 
        
        
      };
       
      
    }
export function organisationCtrl ($scope, $rootScope, $location, $timeout,SettingsService,CodesService,MessagingService) {
    
  
    $scope.CTRLNAME='organisationCtrl';
    $scope.organisationId = $rootScope.globals.currentUser.organisation.id;
    var lang = $rootScope.globals.currentUser.lang;
    //get all codes
      
    //status
   /* CodesService.getCodesByName('codestatus',lang).then(function (data) {
        $scope.statusList = data.data;
    });
     */ 
    $scope.getOrganisationInfo = function () {
        
        SettingsService.getOrganisationInfo($scope.organisationId,lang).then(function(data) {
                                
            $scope.organisation = data.data;
             //country
            CodesService.getCodesByName('countries',lang).then(function (data) {
                $scope.countryList = data.data;
                $scope.countryList.unshift({id:null});
            });
      
            //industry
            CodesService.getCodesByName('industry',lang).then(function (data) {
                $scope.industryList = data.data;
                $scope.industryList.unshift({id:null});
            });
                                  
        },function(error){
                                
            MessagingService.addMessage(error.data.msg,'error');
        });
    
    };
    
    $scope.GenerateApiKeys = function () {
        let api_id;
        if ($scope.organisation.ApiUser == null) api_id = $scope.organisation.ApiUser;
        else api_id = $scope.organisation.ApiUser.username;
        SettingsService.GenerateApiKeys(api_id).then(function(data) {
                                
            $scope.api_id = data.data.api_id;
            $scope.api_key = data.data.api_key;
            
            MessagingService.addMessage(data.data.msg,'success');
            
                                  
        },function(error){
                                
            MessagingService.addMessage(error.msg,'error');
        });
    
    };

     $scope.getOrganisationInfo();
     
    $scope.saveOrganisation = function (isValid) {
          
        if (isValid) {
             
      
            $scope.saveOrganisationExecute = function () {

            //  $scope.auction.currentUser = $rootScope.globals.currentUser;

            };
        }

    }
      
};